<script>
export default {
  name: "s-layout",

  props: {
    customBody: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <div class="s-layout">
    <slot />
    <template v-if="customBody">
      <slot name="body" />
    </template>
    <div v-else-if="$slots.body" class="s-layout__body">
      <slot name="body" />
    </div>
    <footer v-if="$slots.footer" class="s-layout__footer">
      <slot name="footer" />
    </footer>
  </div>
</template>

<style scoped>
.s-layout {
  flex: 1;
  flex-direction: column;
}

.s-layout__body {
  flex: 1 1 0;
  margin: 6px 0;
  overflow: auto;
  flex-direction: column;
}

.s-layout__body>.s-card {
  flex: 1;
  margin: 2px 1px;
}

.s-layout__footer {
  gap: 5px;
  padding: 5px;
  margin-top: auto;
  text-align: right;
  justify-content: flex-end;
  border-top: solid 1px #aaa;
}

.s-layout,
.s-layout__body,
.s-layout__footer {
  display: flex;
  box-sizing: border-box;
}
</style>